/* import __COLOCATED_TEMPLATE__ from './series-custom-times-summary.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import CustomTimesSummary from './custom-times-summary';

export default class SeriesCustomTimesSummary extends CustomTimesSummary {}
